import { render, staticRenderFns } from "./ConfirmationsList.vue?vue&type=template&id=42e40297&"
import script from "./ConfirmationsList.vue?vue&type=script&lang=js&"
export * from "./ConfirmationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports